import { Action } from '@ngrx/store';
import { VelaInput, VelaTemplate } from '@usimweb/core/models';

export const LOAD_TREE_STRUCT = '[Projects] Load Tree Struct';
export const LOAD_TREE_STRUCT_FAIL = '[Projects] Load Tree Struct Fail';
export const LOAD_TREE_STRUCT_SUCCESS = '[Projects] Load Tree Struct Success';

export const UPDATE_TREE = '[Tree] Update tree';
export const UPDATE_VALUE_TREE = '[Tree] Update value';
export const ADD_ACTOR_TREE = '[Tree] Add actor to tree';
export const RM_ACTOR_TREE = '[Tree] Remove actor from tree';
export const CHANGE_TEMPLATE = '[Tree] Change template';

export class LoadStructTree implements Action {
  readonly type = LOAD_TREE_STRUCT;
}

export class LoadStructTreeFail implements Action {
  readonly type = LOAD_TREE_STRUCT_FAIL;
  constructor(public payload: any) {}
}

export class LoadStructTreeSuccess implements Action {
  readonly type = LOAD_TREE_STRUCT_SUCCESS;
  constructor(public payload: VelaTemplate[]) {}
}

export class UpdateTree implements Action {
  readonly type = UPDATE_TREE;
  constructor(public payload: any) {}
}

export class UpdateValueTree implements Action {
  readonly type = UPDATE_VALUE_TREE;

  // define data type as VelaCategory Object type?
  constructor(public payload: { key: string; data: Object; index: number }) {}
}

export class AddActorTree implements Action {
  readonly type = ADD_ACTOR_TREE;
  constructor(public payload: { key: string; data: Object; index: number }) {}
}

export class RmActorTree implements Action {
  readonly type = RM_ACTOR_TREE;
  constructor(public payload: { key: string; index: number }) {}
}

export class ChangeTemplate implements Action {
  readonly type = CHANGE_TEMPLATE;
  constructor(public payload: VelaInput) {}
}

export type TreeActions =
  | LoadStructTree
  | LoadStructTreeFail
  | LoadStructTreeSuccess
  | UpdateTree
  | UpdateValueTree
  | AddActorTree
  | RmActorTree
  | ChangeTemplate;
